module.exports = __webpack_public_path__ + "img/0020.4caa63c8.jpg";